import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import { withRouter } from 'react-router-dom'
import Sidebar from './Sidebar'
import TopBar from './TopBar'
import { getGroupNavItems } from './navConfig'

const styles = (theme) => ({
  root: {
    display: 'flex',
    minHeight: '100vh',
    backgroundColor: theme.palette.background.default,
  },
  main: {
    flexGrow: 1,
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(2),
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(2.5, 3, 4),
    },
  },
  contentInner: {
    width: '100%',
    maxWidth: theme.custom.contentMaxWidth,
    margin: '0 auto',
  },
})

class AppShell extends React.Component {
  state = {
    mobileOpen: false,
  }

  handleDrawerToggle = () => {
    this.setState((state) => ({ mobileOpen: !state.mobileOpen }))
  }

  handleDrawerClose = () => {
    this.setState({ mobileOpen: false })
  }

  render() {
    const {
      classes,
      title,
      subtitle,
      children,
      uniqid,
      navItems,
      secondaryNav,
      showSearch,
      searchValue,
      onSearchChange,
      searchPlaceholder,
      actions,
      location,
    } = this.props

    const resolvedNav =
      navItems ||
      getGroupNavItems({
        uniqid,
        pathname: location.pathname,
      })

    return (
      <div className={classes.root}>
        <Sidebar
          open={this.state.mobileOpen}
          onClose={this.handleDrawerClose}
          navItems={resolvedNav}
          secondaryNav={secondaryNav || []}
        />
        <div className={classes.main}>
          <TopBar
            title={title}
            subtitle={subtitle}
            onMenuClick={this.handleDrawerToggle}
            showSearch={showSearch}
            searchValue={searchValue}
            onSearchChange={onSearchChange}
            searchPlaceholder={searchPlaceholder}
            actions={actions}
          />
          <main className={classes.content}>
            <div className={classes.contentInner}>{children}</div>
          </main>
        </div>
      </div>
    )
  }
}

AppShell.propTypes = {
  classes: PropTypes.object.isRequired,
  title: PropTypes.node,
  subtitle: PropTypes.node,
  children: PropTypes.node,
  uniqid: PropTypes.string,
  navItems: PropTypes.array,
  secondaryNav: PropTypes.array,
  showSearch: PropTypes.bool,
  searchValue: PropTypes.string,
  onSearchChange: PropTypes.func,
  searchPlaceholder: PropTypes.string,
  actions: PropTypes.node,
  location: PropTypes.object.isRequired,
}

export default withRouter(withStyles(styles)(AppShell))
